// Centralised external link constants — single source of truth.
// Update a URL here and every CTA across the site stays in sync.

// BTX secondary marketplace (Arizore referral link). Must be kept exact.
export const BTX_REFERRAL_URL = 'https://btassethub.digital/?referral-code=89bgt';
